import { useTranslation } from 'react-i18next';
import Icon from './empty-state-image.svg';
import s from './index.module.scss';

export const EmptyState = () => {
  const { t } = useTranslation();

  return (
    <div className={s.empty}>
      <div className={s.content}>
        <img src={Icon} alt="empty" width={128} height={128} />
        <div className="f-body-md f-500">
          {t('bank_accounts:empty_state.title')}
        </div>
        <div className="f-body-sm">
          {t('bank_accounts:empty_state.description')}
        </div>
      </div>
    </div>
  );
};